import { useEffect, useState } from "react";
import getClientSideSplitTreatments from "./getClientSideSplitTreatments";
const LOADING_STATE = Object.freeze({
    isLoading: true,
    treatments: {},
});
/**
 * Hook to get client-side treatments with a loading state.
 * @param treatmentNames - The name(s) of treatments being fetched
 * @param splitKey - The Split key (or Promise of Split key) to be used
 * @param options.apiPathString - The path to your application's treatment endpoint to override default.
 * @param options.attributes - Additional attributes to send to Split.
 * @returns {TreatmentState} The `treatments` property of the returned object is of type `Record<never, never>` while `isLoading` is true to ensure the loading state is handled before the treatments are accessed.
 **/
const useClientSideSplitTreatments = (treatmentNames, splitKey, options = {}) => {
    const [treatments, setTreatments] = useState(LOADING_STATE);
    useEffect(() => {
        setTreatments(LOADING_STATE);
        const abortController = new AbortController();
        getClientSideSplitTreatments(treatmentNames, splitKey, {
            abortController,
            apiPathString: options.apiPathString,
            attributes: options.attributes,
        }).then((treatments) => {
            setTreatments({ isLoading: false, treatments });
        });
        return () => {
            abortController.abort();
        };
    }, [JSON.stringify(treatmentNames)]);
    return treatments;
};
export default useClientSideSplitTreatments;
